import React, { Component } from "react"
import WidgetsManagement from "../WidgetsManagement"
import WishlistPage from "../WishlistPage"
import ComparePage from "../ComparePage"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "./../../actions"
function mapStateToProps(state) {
    return {
        pages: state.pages,
        pages_config: state.pages_config,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class Widgets extends Component {
    constructor(props) {
        super(props)

        this.state = {
            page: JSON.parse(JSON.stringify(props.pages_config)),
        }
    }

    static getDerivedStateFromProps(props, state) {
      const { pages_config } = props
      return { page: JSON.parse(JSON.stringify(pages_config)) }
  }

    handleChangeTabs = (value) => {
        this.setState({ page: value })
        this.props.actions.switchPagesConfigAction(value)
    }

    render() {
        const { page } = this.state
        const { pages } = this.props
        console.log('page', page)
        switch (page) {
            case "WidgetsManagement":
                return (
                    <WidgetsManagement redirectToPage={(value) => this.handleChangeTabs(value)} />
                )

            case "WidgetsSetting":
                if (pages.selected == 1) {
                    return <WishlistPage redirectToPage={(value) => this.handleChangeTabs(value)} />
                } else {
                    return <ComparePage redirectToPage={(value) => this.handleChangeTabs(value)} />
                }
            default:
                return (
                    <WidgetsManagement redirectToPage={(value) => this.handleChangeTabs(value)} />
                )
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Widgets)
